import React from "react";
import { Typography, Box } from "@mui/material";
//TODO: based on Section component. remove section later
const ownSx = {
  panel: {
    maxWidth: "980px",
    borderRadius: "8px",
    gap: "40px"
  },
  header: {
    display: "flex",
    alignItems: "center",
    padding: "0px 20px 0px 20px",
    height: "50px",
    color: "blue.c100",
    backgroundColor: "blue.c20",
    borderRadius: "8px 8px 0px 0px"
  },
  content: {
    backgroundColor: "common.white",
    "& > *:not(:last-child)": {
      borderBottom: (theme) => `1px solid ${theme.palette.blue.c20}`
    },
    "&:last-child": {
      borderBottomLeftRadius: "8px",
      borderBottomRightRadius: "8px"
    }
  }
};

function Panel({ title, children }) {
  return (
    <Box sx={ownSx.panel}>
      <Box sx={ownSx.header}>
        <Typography variant="body1B">{title}</Typography>
      </Box>
      <Box className="panel__content" sx={ownSx.content}>
        {children}
      </Box>
    </Box>
  );
}

export default Panel;
